/**
 * Cooling Badge Component
 *
 * Snowflake indicator + count of a task's temperature-controlled (cold-chain)
 * orders. Shared by every surface that shows a task's total order count
 * (Tasks page, tasks in a route, add-stop-to-route picker) so the indicator
 * looks and behaves identically everywhere. Renders nothing when the task has
 * no cooling orders.
 */

import { Snowflake } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface CoolingBadgeProps {
  /** Number of orders in the task with temperature_control = true. */
  count?: number | null;
  className?: string;
}

export function CoolingBadge({ count, className }: CoolingBadgeProps) {
  if (!count || count <= 0) return null;

  const label = `${count} order${count === 1 ? '' : 's'} requiring temperature control`;

  return (
    <span
      title={label}
      aria-label={label}
      className={cn(
        'inline-flex items-center gap-0.5 font-medium rounded-full',
        'bg-sky-100 text-sky-700 px-2 py-0.5 text-[10px] whitespace-nowrap',
        className
      )}
    >
      <Snowflake className="h-3 w-3 flex-shrink-0" aria-hidden="true" />
      {count}
    </span>
  );
}
